import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FiTrendingUp } from 'react-icons/fi';
import NodeWrapper from './NodeWrapper';
import { VISUAL_NODE_HEIGHT_CLASS } from '../layoutConfig';
import { getNodeAccent } from '../config/nodeVisualConfig';

const HeikinAshiNode = memo(({ data, selected }) => {
  const accent = getNodeAccent('heikin_node', data);
  return (
    <NodeWrapper
        selected={selected}
        title="Heikin Ashi"
        type="VISUALIZATION"
        accent={accent}
        icon={FiTrendingUp}
        className={`${VISUAL_NODE_HEIGHT_CLASS} flex flex-col`}
        isHighlighted={data.isHighlighted}
    >
        {/* Input: Data Source */}
        <Handle
            type="target"
            id="input_0"
            position={Position.Left}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />

        <div className="space-y-2">
             <div className="flex gap-1 justify-center bg-bg-3 p-2 rounded border border-[var(--divider)]">
                <div className="w-2 h-6 rounded-sm relative" style={{ backgroundColor: data.upColor || '#00C292' }}>
                    <div className="absolute top-0 bottom-0 left-1/2 w-px -translate-x-1/2 -z-10 h-8 -mt-1" style={{ backgroundColor: data.wickUpColor || data.upColor || '#00C292' }}></div>
                </div>
                <div className="w-2 h-6 rounded-sm relative mt-2" style={{ backgroundColor: data.downColor || '#E46A76' }}>
                     <div className="absolute top-0 bottom-0 left-1/2 w-px -translate-x-1/2 -z-10 h-8 -mt-1" style={{ backgroundColor: data.wickDownColor || data.downColor || '#E46A76' }}></div>
                </div>
             </div>
             <div className="text-[9px] text-center text-fg-3">Smoothed Trend</div>
        </div>

        {/* Output: Configuration Source — accent-tinted */}
        <Handle
            type="source"
            position={Position.Right}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />
    </NodeWrapper>
  );
});

export default HeikinAshiNode;
